/**
 * Component to display audit log
 */
import * as React from 'react';
import { Card, Breadcrumb, Input, Button, Row, Col, Radio, DatePicker, Table, Dropdown, Menu, Icon, Modal } from 'antd';
import moment from 'moment';
import '../css/AuditLog.scss';
import service from '../service/apolloclient.service';
import Utils from './common/utils';
import Token from './common/token';
import { STATICKEYS, staticProperties } from './common/staticProperties';
import { VIEWSTATE } from './common/constants';
import LocalStorage from '../service/localstorage';
import UnAuthorized from './errorPages/unauthorized';
import Auth from './common/auth';
import { Tasks } from './common/auth';
import strings from '../eyeguide-localization/strings.auditlog';
import Export from './common/export';

const storage = new LocalStorage();
const RadioGroup = Radio.Group;
const dateFormat = 'MM/DD/YYYY';
const {  RangePicker } = DatePicker;

interface IAduitLogState {
    classesWithErr: string;
    classesWithoutErr: string;
    logOption: number;
    startDate: any;
    endDate: any;
    rowsNum: string;
    columns: Array<any>;
    columnData: Array<any>;
    loading: boolean;
    pagination: any;
    emptyText: string;
    showLogs: boolean;
    username: string;
    searchVal: string;
    logs: any;
    isFocusUser: boolean;
    errorname: boolean;
    errorrowsNum: boolean;
    errorstartDate: boolean;
    errorendDate: boolean;
    exportModalVisisble: boolean;
    canViewShareAudit: boolean;
}

export default class AuditLog extends React.Component<{}, IAduitLogState> {
    menu = (
        <Menu onClick={() => this.exportFile()}>
          <Menu.Item key="1">CSV</Menu.Item>
        </Menu>
    );
    constructor(props: any) {
        super(props);
        let roleid: number = parseInt(Token.decodeToken().roleid, 10);
        this.state = {
            classesWithErr : 'fill errorHighlight',
            classesWithoutErr: 'fill',
            logOption: 1,
            startDate: undefined,
            endDate: undefined,
            rowsNum: '',
            columns: [],
            columnData: [],
            loading: false,
            pagination: {},
            emptyText: '',
            showLogs: false,
            username: '',
            searchVal: '',
            logs: [],
            isFocusUser: Auth.canPerformTask(roleid, Tasks.isFocusUser),
            errorname: false,
            errorrowsNum: false,
            errorstartDate: false,
            errorendDate: false,
            exportModalVisisble: false,
            canViewShareAudit: Auth.canPerformTask(roleid, Tasks.canViewShareAudit)
        };
        staticProperties.set(STATICKEYS.selectedKey, VIEWSTATE.AUDIT);
    }

    componentDidMount() {
        // console.log('history', this.props.location.state);
        if (this.state.isFocusUser) {
        if (storage.getSelectedOrgName() !== '') {
            this.logoutFromOrg();
        }
    }
    }

    render() {
        if (!this.state.isFocusUser || !this.state.canViewShareAudit) {
        return (
            <UnAuthorized/>
        );
        } else {
        return (
            <div className="AuditLog">
                <Card >
                    <Breadcrumb>
                        <Breadcrumb.Item><a href="/dashboard">{strings.lsHomeTxt}</a></Breadcrumb.Item>
                        <Breadcrumb.Item>{strings.lsAuditLogTxt}</Breadcrumb.Item>
                    </Breadcrumb>
                        <br/>
                    <h3>{strings.lsAuditLogTxt} </h3>
                </Card>
                <div className="contentWithoutTitle">
                    <Card 
                        bordered={false}
                        className="card"
                    >
                    {!this.state.showLogs ?
                        <div>
                            <Row className="row">
                                <Col xs={1} sm={1} md={2} lg={5} xl={5} >
                                    <Input 
                                        placeholder={strings.lsEnterNamePlaceholderTxt}
                                        value={this.state.username} 
                                        onChange={(val) => this.setState({username: val.target.value})}
                                        className={this.state.errorname ? 
                                            this.state.classesWithErr : this.state.classesWithoutErr}
                                        autoFocus={true}
                                    />
                                </Col>
                            </Row>
                            <Row className="logOption">
                                <Col xs={14} sm={14} md={16} lg={10} xl={11}>
                                    <RadioGroup 
                                        className="labelFrame" 
                                        value={this.state.logOption} 
                                        onChange={(val) => this.setState
                                            ({logOption: val.target.value,
                                                errorrowsNum: false,
                                                errorstartDate: false,
                                                errorendDate: false
                                            })}
                                        
                                    >
                                        <Radio defaultChecked={true} value={1}>{strings.lsLogOptionTxt1}</Radio>
                                        <Radio defaultChecked={false} value={2}>{strings.lsLogOptionTxt2}</Radio>
                                    
                                    </RadioGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={14} sm={14} md={16} lg={10} xl={5}>
                                    {this.state.logOption === 1 ? 
                                    <Input 
                                        placeholder={strings.lsEnterRowsPlaceholderTxt}
                                        value={this.state.rowsNum} 
                                        onChange={(val) => this.setState({rowsNum: val.target.value})}
                                        className={this.state.errorrowsNum ? 
                                            this.state.classesWithErr : this.state.classesWithoutErr}
                                    />
                                        
                                    :
                                    <RangePicker 
                                            onChange={(date: any, dateString: any) => {
                                                console.log('datestring', dateString.toString()); 
                                                if (dateString.toString().split(',').length >= 2 
                                                && dateString.toString() !== ',' ) {
                                                this.setState({startDate: dateString.toString().split(',')[0] ,
                                                    endDate: dateString.toString().split(',')[1] });
                                                } else {
                                                    this.setState({startDate: undefined ,
                                                    endDate: undefined });
                                                }
                                        }}
                                            format={dateFormat} 
                                            value={  this.state.startDate !== undefined &&
                                                    this.state.endDate !== undefined ?
                                                    [moment(this.state.startDate), moment(this.state.endDate)] 
                                                : []
                                                }
                                    />
                                    }
                                </Col>
                            </Row>
                            <Button 
                                className="submit" 
                                type="primary"
                                onClick={() => this.getAutiLog()}
                            > 
                            {strings.lsSubmitTxt} 
                            </Button>
                        </div>
                        : 
                        <div>
                            <Row className="searchRow">
                                <Col xs={10} sm={10} md={10} lg={10} xl={5}>
                                    <Input 
                                        placeholder={strings.lsSearchPlaceholderTxt} 
                                        value={this.state.searchVal} 
                                        onChange={(val) => { 
                                             this.setState({searchVal: val.target.value});
                                            }
                                        }
                                    />
                                </Col>
                                <Col xs={10} sm={10} md={10} lg={5} xl={3}>
                                    <Button 
                                        type="primary"
                                        className="search"
                                        onClick={() => this.onSearch()}
                                    > {strings.lsSearchTxt} 
                                    </Button>
                                </Col>
                                {/* <div className="rightBtns"> */}
                                
                                {/* <Col xs={14} sm={14} md={16} lg={10} xl={5}> */}
                                    <Button 
                                        className="backBtn"
                                        onClick={() => this.clearForm()}
                                    > {strings.lsBackTxt} 
                                    </Button>
                                {/* </Col>
                                <Col xs={14} sm={14} md={16} lg={10} xl={5}> */}
                                    <Dropdown 
                                        trigger={['click']}
                                        overlay={this.menu}
                                        getPopupContainer={this.getContainer}
                                    ><Button className="downloadBtn"> 
                                        {strings.lsDwnldTxt} <Icon type="down" style={{ fontSize: 10}}/> </Button>
                                    </Dropdown>
                                {/* </Col> */}
                                {/* </div> */}
                            </Row>
                            <Table
                                columns={this.state.columns} 
                                dataSource={this.state.columnData} 
                                pagination={this.state.pagination}
                                rowKey={record => record.testid}
                                loading={this.state.loading}
                                locale={{ emptyText: this.state.emptyText }} 
                            />
                            <Modal
                                title={strings.lsExportLogTxt}
                                visible={this.state.exportModalVisisble}
                                onOk={() => this.setState({exportModalVisisble: false})}
                                okText={strings.lsOkTxt}
                                width={450}
                                bodyStyle={{padding: 0 }}
                                maskClosable={false}
                                closable={false}
                                footer={[
                                    <Button 
                                            key="Ok" 
                                            type="primary"  
                                            onClick={() => this.setState({exportModalVisisble: false})}
                                    >
                                    {strings.lsOkTxt}
                                    </Button>,
                                ]}
                            >
                                <Row style={{padding: '19px'}}>
                                    {strings.lsExportLogSuccessTxt}
                                </Row>
                            </Modal>
                        </div> }
                    </Card>
                </div>
            </div>
        );
    }
    }

    /**
     * Fetch Audit logs from server as per the criteria selected by user
     */
    private async getAutiLog() {
        console.log('getAutiLog');
        if (this.validateInput()) {
        let ser = new service();
        let input: any = {username: this.state.username, 
                    numberofrecords: this.state.rowsNum !== '' ? this.state.rowsNum : 0, 
                    startDate: Utils.getDateInFormart(this.state.startDate),
                     endDate: Utils.getDateInFormart(this.state.endDate)};
        console.log(input);
        let resp = await ser.focuslogs(this.state.logOption, input);
        console.log('response', resp);
        let columns: any = this.buildColumn();
        let columnData: any = this.buildData(resp);
        const pagination = { ...this.state.pagination };
        pagination.total = columnData.length;
        pagination.pageSize = 20 ;
        pagination.pageSizeOptions = ['20', '50', '75', '100'];
        pagination.showSizeChanger = true ;  
        pagination.showTotal = function (total: any) {
                return strings.formatString(strings.lsAuditLogTotalTxt, total);
        };
        this.setState({
            columnData,
            columns,
            showLogs: true,
                logs: resp,
                pagination,
                searchVal: ''
        });
        }
    }

    /**
     * This function builds the data required by the Table component to display the logs
     * @param logs 
     */
    private buildData(logs: any) {
        console.log('buildData');
        let columnData: Array<any> = [];
        logs.forEach( (element: any) => {
            let data = {
                logtimestamp: element.logtimestamp,
                datetime: Utils.getDate(element.logtimestamp) + ' ' + Utils.getTime(element.logtimestamp),
                event: element.event
            };
            columnData.push(data);
        }); 
        return columnData;
    }   

    /**
     * This function builds the data required by the Table component to display the logs
     * @param logs 
     */
    private buildExportData(logs: any) {
        console.log('buildData');
        let columnData: Array<any> = [];
        logs.forEach( (element: any) => {
            let data = {
                datetime: Utils.getDate(element.logtimestamp) + ' ' + Utils.getTime(element.logtimestamp),
                event: element.event
            };
            columnData.push(data);
        }); 
        return columnData;
    }  

    /**
     * This function returns the column setting for use with the Table component
     */
    private buildColumn() {
        console.log('buildColumn');
        let columns = [
          {
            title: strings.lsDateTimeTxt,
            dataIndex: 'datetime',
            className: 'rows',
            width: 150
          },
          {
              title: strings.lsEventTxt,
              dataIndex: 'event',
              className: 'rows'
          } 
        ];
        return columns;
    }

    /**
     * This function is called on serach button click.
     */
    private onSearch() {
        let value: string = this.state.searchVal;
        let pagination = this.state.pagination;
        
        let logs: any = [];
        this.state.logs.forEach((e) => {
            if (e.event.indexOf(value) > -1) {
                logs.push(e);
            }
        });
        let data = this.buildData(logs);
        pagination.total = logs.length;
        this.setState({
            columnData: data,
            pagination
        });
    }

    /**
     * Validate input values provided by the user before submitting to server 
     */
    private validateInput(): boolean {
        let isValid: boolean = true;
        let errorname: boolean = false;
        let errorrowsNum: boolean = false;
        let errorstartDate: boolean = false;
        let errorendDate: boolean = false;
        this.state.username !== null && (this.state.username === undefined 
                || this.state.username.trim() === '') ? 
                    errorname = true : errorname = false;
        if (this.state.logOption === 1) {
        this.state.rowsNum !== null && 
                    (this.state.rowsNum === undefined || this.state.rowsNum.trim() === '') 
                        ? errorrowsNum = true 
                    : errorrowsNum = false;
        } else {
        this.state.startDate !== null && 
                    (this.state.startDate === undefined || this.state.startDate.trim() === '')
                    ? errorstartDate = true 
                    : errorstartDate = false;
        this.state.endDate !== null &&  
                    (this.state.endDate === undefined || this.state.endDate.trim() === '') 
                    ? errorendDate = true 
                : errorendDate = false;
        }
        if (errorname || errorrowsNum || errorstartDate || errorendDate) { isValid = false; }
        this.setState({errorname, errorrowsNum, errorstartDate, errorendDate});
        return isValid;
      }

    /**
     * Logs out from Logged in organization.
     */
    private logoutFromOrg() {
        storage.setSelectedOrg('');
        storage.setSelectedOrgName('');
        storage.setSelectedOrgPrimary('');
        window.location.href = '/dashboard' ;
    }
        
    /**
     * Builds export data and calls export util
     */
    private async exportFile() {
        console.log('usersForPrint', this.state.logs);
        let buildData: any;
        buildData = this.buildExportData(this.state.logs);
        if (buildData.length > 0) {
            Export.exportCSVFile(buildData, strings.lsAuditLogsTxt);
            this.setState({exportModalVisisble: true});
        }
    }

    /**
     * sets the container element for dropdown menu
     */
    private getContainer = (triggernode) => {
        return triggernode.parentNode;
    }

    private clearForm() {
        this.setState({
            endDate: undefined,
            startDate: undefined,
            rowsNum: '',
            username: '',
            showLogs: false,
            logOption: 1
        });
    }
    
}


// WEBPACK FOOTER //
// ./src/components/AuditLog.tsx